import { useState } from "react";
import { api } from "../../../../service/api";

export function useDeleteLocator() {
  const [loadingDelete, setLoadingDelete] = useState(false);

  const deleteLocator = async (id: string) => {
    try {
      setLoadingDelete(true);
      await api.delete("company/locator/delete/" + id);
    } catch (error) {
      throw error;
    } finally {
      setLoadingDelete(false);
    }
  };

  return { loadingDelete, deleteLocator };
}
